import { render, staticRenderFns } from "./CourseTerms.vue?vue&type=template&id=4cf30382&scoped=true"
import script from "./CourseTerms.vue?vue&type=script&lang=js"
export * from "./CourseTerms.vue?vue&type=script&lang=js"
import style0 from "./CourseTerms.vue?vue&type=style&index=0&id=4cf30382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf30382",
  null
  
)

export default component.exports